'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAgentRespondersList = undefined;

var _reselect = require('reselect');

var _getAllAgentResponders = require('./getAllAgentResponders');

var getAgentRespondersList = exports.getAgentRespondersList = (0, _reselect.createSelector)([_getAllAgentResponders.getAllAgentResponders], function (respondersMap) {
  return respondersMap.toList();
});


//////////////////
// WEBPACK FOOTER
// ./js/responders/selectors/getAgentRespondersList.js
// module id = 284
// module chunks = 2 3